<template>
  <div>
    <h1 class="page-header">{{ $t('product.product') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              class="mr-2"
              outline
              @click="$router.push({ name: 'product-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
            <ts-button @click="showForm">
              {{ $t('product.copyPrice') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'category.category_name_en'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.barcode }}</td>
          <td class="kh-font">{{ record.product_name_kh }}</td>
          <td>{{ record.product_name_en }}</td>
          <td class="text-center">
            {{
              record.u_o_m_category
                ? record.u_o_m_category.uom_cat_name_en
                : null
            }}
          </td>
          <td class="text-center">
            <span v-if="record.is_expired">
              <i class="far fa-check-square text-primary"></i
            ></span>
            <span v-else><i class="far fa-window-close text-danger"></i></span>
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import CopyPriceForm from './copy-price-from.vue'

export default {
  name: 'product',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('product.barcode') },
        { name: this.$t('product.nameKH') },
        { name: this.$t('product.nameEN') },
        { name: this.$t('product.uomCategory'), style: 'text-align:center' },
        {
          name: this.$t('product.expirationAvailable'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('product', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.search
      },
      set(newValue) {
        this.$store.commit('product/SET_SEARCH', newValue)
        this.$store.commit('product/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('product/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'product-edit',
        params: { id: record.product_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('product/destroy', record.product_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm() {
      this.$modal.show(
        CopyPriceForm,
        {
          data: []
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'product-create') {
      this.$store.commit('product/RESET_STATE')
    }
    next()
  }
}
</script>
